import type { CatalogImage } from '@/features/catalog-image/types';

export type WalkIncidentType =
  | 'INJURY'
  | 'LOST'
  | 'AGGRESSION'
  | 'HEALTH'
  | 'BEHAVIOR'
  | 'WEATHER'
  | 'OTHER';

export type WalkIncidentSeverity = 'INFO' | 'URGENT';
export type WalkIncidentStatus = 'OPEN' | 'RESOLVED';

export type WalkIncident = {
  id: string;
  booking_id: string;
  type: WalkIncidentType;
  severity: WalkIncidentSeverity;
  note: string;
  status: WalkIncidentStatus;
  resolution_note: string | null;
  resolved_at: string | null;
  owner_acknowledged_at: string | null;
  created_at: string;
  photos: CatalogImage[];
};

export const INCIDENT_TYPE_LABEL: Record<WalkIncidentType, string> = {
  INJURY: 'Injury',
  LOST: 'Lost dog',
  AGGRESSION: 'Aggression',
  HEALTH: 'Health',
  BEHAVIOR: 'Behaviour',
  WEATHER: 'Weather',
  OTHER: 'Other',
};

export const INCIDENT_TYPES: WalkIncidentType[] = [
  'INJURY',
  'LOST',
  'AGGRESSION',
  'HEALTH',
  'BEHAVIOR',
  'WEATHER',
  'OTHER',
];
